import React, { useContext } from 'react';

import LazyLoad from 'react-lazyload';
import { withRouter } from 'react-router-dom'

import { useStore, getIsAuthenticated } from '../../../Store'
import Hero from "../../../components/hero";
import ExampleCompanionWebsite from '../../../components/ExampleCompanionWebsite';
import Checks from './Checks';
import Features from './Features';
import Testimonial from '../../../components/Testimonial'
import PullRequestCheck from '../../../components/PullRequestCheck'
import FeatureReleaseNotes from '../../../components/FeatureReleaseNotes'
import Price from '../../Price'
import Seo from '../../../components/Seo'
import { useProduct } from '../../../hooks/useProduct'
import { defaultExamplePythonRepos } from '../../../hooks/useOctokit'
import HowItWorks from '../../../components/HowItWorks'



export default withRouter(function(props) {
  const { state } = useStore()
  const isAuthenticated = getIsAuthenticated(state)
  const productDetails = useProduct()

  // doing this only on first page load
  // will not redirect on page refresh or on internal navigation
  // will redirect on first page load
  if (window.history.state === null && !window.location.hash) {
    if (isAuthenticated) {
//      props.history.push('/@me')
    }
  }

  return (
    <>
      <Seo
        title={productDetails.name}
        description={`Your code review copilot for ${productDetails.stack} that suggests improvements`}
      />
      <Hero
        headline={`Your ${productDetails.stack} code review copilot`}
        synopsis={`${productDetails.name} suggests ${productDetails.stack} improvements right inside your pull request.`}
        linkUrl={`${productDetails.gitHubMarketplaceLink}#pricing-and-setup`}
        linkText={"Add to GitHub"}
        examplesCodes={['NoBreakpoint', 'NoMissingComma', 'AwaitAsyncCall', 'NoRedundantListComprehension', 'ComparePrimitivesByEqual', 'ExplicitFrozenDataclass', 'UseAssertIn']}
      />
      <PullRequestCheck />
      <Features />
      <Testimonial />
      <LazyLoad height="545px">
        <HowItWorks />
      </LazyLoad>
      <LazyLoad height="1600px">
        <ExampleCompanionWebsite exampleRepos={defaultExamplePythonRepos} />
      </LazyLoad>
      <LazyLoad height="3000px">
        <Checks />
      </LazyLoad>
      <Price saasModel={true} selfHostedModel={false} showCatalogue={true} />
    </>
  )
})

      